import { render, staticRenderFns } from "./billTabs.vue?vue&type=template&id=29ccbc3a&"
import script from "./billTabs.vue?vue&type=script&lang=js&"
export * from "./billTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports